import React, {Component} from 'react';
import {Button, Grid, Select, Typography} from '@material-ui/core';
import {connect} from 'react-redux';
import {primaryColor, textBlack, textPrimary, webFont} from "../../config/theme";
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import {compose, graphql} from "react-apollo";
import { getUser } from "../../redux/user";
import {UPDATE} from "../../graphql/mutations/user";
import { UPDATE_IN_PROGRESS_BOOKING } from '../../graphql/mutations/booking';
import UPDATE_CHEF from "../../graphql/mutations/chef/update_chef";
import Fab from "@material-ui/core/Fab/Fab";
import {NotificationManager} from "react-notifications";
import {stateList} from "../../config/constants";
import { setCustomBookingAddress } from '../../redux/bookings';
import { validateAddress } from "../../utils/address-validation";

class InProgress3 extends Component {

  state = {
    user: this.props.isChef ? this.props.chef : this.props.diner,
    initialState: {
      name: "",
      cellPhone: "",
      emailId: "",
      address: {
        street1: "",
        street2: "",
        city: "",
        state: "",
        zip: ""
      },

    },
    errors: {
      name: "",
      cellPhone: "",
      emailId: "",
      address: {
        street1: "",
        street2: "",
        city: "",
        state: "",
        zip: ""
      }
    }
  };

  handleChange = (name, e) => {
    let errors = this.state.errors;
    let address = this.state.initialState.address;
    let re = /^[a-zA-Z ]+$/;
    const {chef} = this.props;
    const {diner} = this.props;
    const user = this.props.isChef ? chef : diner;
    let {initialState} = this.state;

    switch (name) {

      case "name":
        if (!re.test(e.target.value)) {
          errors.name = 'Please enter a valid name';
        } else {
          errors.name = '';
        }
        initialState.name = e.target.value;
        break;

      case "cellPhone":
        const mobile = e.target.value;

        if (!/^\d+$/.test(mobile.trim())) {
          errors.cellPhone = 'Please enter only numbers';
        } else if (mobile.trim().length !== 10) {
          errors.cellPhone = 'Please enter a valid phone number (10 digits)';
        } else {
          errors.cellPhone = '';
        }
        initialState.cellPhone = e.target.value;
        break;
      case "emailId":
        let value = e.target.value;
        let emailIdValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        if (!emailIdValid) {
          errors.emailId = 'Please enter a valid emailId';
        } else {
          errors.emailId = '';
        }
        initialState.emailId = e.target.value;
        break;
      case "city":
        if (!re.test(e.target.value)) {
          errors.address.city = 'Please enter a valid city';
        } else {
          errors.address.city = '';
        }
        initialState.address.city = e.target.value;
        break;
      case "state":
        /*if (!re.test(e.target.value) || e.target.value.length > 2) {
            errors.address.state = 'Please enter a valid State code (eg: CA)';
        } else {
            errors.address.state = '';
        }*/
        initialState.address.state = e.target.value.toUpperCase();
        break;
      case "street1":
        const poRegex = /^(?!.*(?:(.*((p|post)[-.\s]*(o|off|office)[-.\s]*(box|bin)[-.\s]*)|.*((p |post)[-.\s]*(box|bin)[-.\s]*)))).*$/i;
        if (e.target.value == "") {
          errors.address.street1 = 'The field can not be blank';
        } else if (!poRegex.test(e.target.value)) {
          errors.address.street1 = 'Please enter a physical address';
        }else {
          errors.address.street1 = '';
        }
        initialState.address.street1 = e.target.value;
        break;
      case "street2":
        initialState.address.street2 = e.target.value;
        break;
      case "zip":
        value = e.target.value;
        if ((value.length !== 5) || (e.target.value != "" && isNaN(e.target.value))) {
          errors.address.zip = 'Please enter a valid zip code';
        } else {
          errors.address.zip = '';
        }
        initialState.address.zip = e.target.value;
        break;
    }
    this.setState({initialState: {...this.state.initialState, ...initialState}});
    this.setState({errors: {...this.state.errors, ...errors}});
  };

  componentDidMount() {
    let user = this.props.isChef ? this.props.chef : this.props.diner;
    let initialState = {
      name: `${user.firstName} ${user.lastName}`,
      cellPhone: user.cellPhone,
      emailId: user.emailId,
      address: user.address ? {
        street1: user.address.street1,
        street2: user.address.street2,
        city: user.address.city,
        state: user.address.state || '',
        zip: user.address.zip
      } : {
        street1: null,
        street2: null,
        city: null,
        state: '',
        zip: null
      }
    };
    this.setState({initialState: {...this.state.initialState, ...initialState}}, () => {
      if (this.props.customBookingAddress) {
        if (this.props.customBookingAddress.city) {
          let initState = {
            name: `${user.firstName} ${user.lastName}`,
            cellPhone: user.cellPhone,
            emailId: user.emailId,
            address: this.props.customBookingAddress ? {
              street1: this.props.customBookingAddress.street1,
              street2: this.props.customBookingAddress.street2,
              city: this.props.customBookingAddress.city,
              state: this.props.customBookingAddress.state || '',
              zip: this.props.customBookingAddress.zip
            } : {
              street1: null,
              street2: null,
              city: null,
              state: '',
              zip: null
            }
          };

          this.setState({initialState: {...this.state.initialState, ...initState}});
        }
      }
    });
  }

  submitDetail = async (event) => {
    event.preventDefault();

    const {updateInProgressBooking, updateChef, dispatch, inProgressBooking, updateUser, diner} = this.props;

    this.setState({editAddress: false});
    let formData = this.state.initialState;

    let name = formData.name.split(" ");

    const addrStr = formData.address.street1 + ' ' + formData.address.street2 + ', ' + formData.address.city + ', ' + formData.address.state + ' ' + formData.address.zip;
    const locality = formData.address.city;

    const isValidAddr = await validateAddress(addrStr, locality);

    if (isValidAddr.length) {
      NotificationManager.error('The address is invalid. Please input a valid one.', 'Address', 4500);
      return false;
    }

    if (this.validateDetails(formData)) {
      let payload = {
        userId: this.props.userId,
        chefId: this.props.selectedChefId || this.props.selectedChef.id,
        address: {
          street1: formData.address.street1,
          city: formData.address.city,
          state: this.state.initialState.address.state,
          zip: formData.address.zip,
          country: "US"
        },
      };

      let userPayload = {
        id: this.props.userId,
        emailId: formData.emailId,
        firstName: name[0],
        lastName: name[1],
        cellPhone: formData.cellPhone,
        address: {
          street1: formData.address.street1,
          city: formData.address.city,
          state: this.state.initialState.address.state,
          zip: formData.address.zip,
          country: "US"
        },
      zipcode: formData.address.zip,
      };

      let chefPayload = {
        userId: this.props.userId,
        address: {
          street1: formData.address.street1,
          city: formData.address.city,
          state: this.state.initialState.address.state,
          zip: formData.address.zip,
          country: "US"
        },
      };

      if (formData.address.street2) {
        userPayload.address.street2 = formData.address.street2;
        payload.address.street2 = formData.address.street2;
        chefPayload.address.street2 = formData.address.street2;
      }

      if (diner) { // update user address as well if it does not exists
        if (!diner.address || !diner.address.city) {
          updateUser({
            variables: {user: userPayload}
          }).then((res) => {
            //NotificationManager.info('Address updated in your profile .')
            dispatch(getUser(this.props.userId));
          }).catch(err => {
            console.log(JSON.parse(JSON.stringify(err)))
          });
        }
      }

      if (inProgressBooking) {
        updateInProgressBooking({
          variables: {
            bookingId: inProgressBooking,
            booking: payload
          }
        })
          .then(res => {
            // NotificationManager.info('Address updated for booking.')
            this.props.dispatch(setCustomBookingAddress(payload.address));
          })
          .catch(err => {
            console.log(JSON.parse(JSON.stringify(err)));
          });
      }

      if (this.props.isChef) {
        updateChef({
          variables: {chef: chefPayload}
        }).then((res) => {
        }).catch(err => {
          console.log(JSON.parse(JSON.stringify(err)))
        })
      }

      this.props.stepOne ? this.props.closeModal() : this.props.changeProgressStep(5);
    }
  };

  validateDetails(formData) {
    let stateErrors = this.state.errors;
    let validated = true;

    if (formData.name == '' ||
      formData.emailId == "" ||
      formData.address.street1 == "" ||
      formData.address.city == "" ||
      formData.address.state == "" ||
      formData.address.zip == "") {
      validated = false;
      NotificationManager.error("All fields are required");
    } else {
      for (let key in stateErrors) {
        if (stateErrors[key]) {
          if (key == 'address') {
            for (let addressKey in stateErrors[key]) {
              if (stateErrors[key][addressKey]) {
                validated = false
              }
            }
          } else {
            validated = false
          }
        }
      }
    }
    return validated;
  }

  render() {
    const {chef} = this.props;
    const {diner} = this.props;
    const {initialState} = this.state;
    let user = this.props.isChef ? chef : diner;
    let isCreated = user && !!user.id;

    return (
      <Grid container style={{margin: '10px 0 20px 0'}}>
        <form style={{width:'100%'}} onSubmit={this.submitDetail}>
          <Grid container>
            <Grid item xs={12}>
              <Typography style={{...styles.setFont, fontSize: 24, fontWeight: 500, color: '#000', marginBottom: 15,}}>
                Please review and input address at which service is to be rendered.
              </Typography>
            </Grid>
          </Grid>

          <Grid container style={{margin: '10px 0 15px 0'}}>
            <Grid item xs={12}>
              <InputLabel style={styles.ftText}>NAME</InputLabel><br/>
              <Input
                name={"name"}
                placeholder={"Jose Stevens"}
                label={"NAME"}
                fullWidth
                type={"text"}
                value={initialState.name}
                onChange={(e) => {
                  this.handleChange('name', e)
                }}
                style={styles.inputText}
              />
              <FormHelperText id="component-error-text"
                              style={styles.error}>{this.state.errors.name}</FormHelperText>
            </Grid>
          </Grid>
          <Grid container style={{margin: '10px 0 15px 0'}}>
            <Grid item xs={12}>
              <InputLabel style={styles.ftText}>PHONE NUMBER</InputLabel><br/>
              <Input
                name={"cellPhone"}
                placeholder={"Phone Number"}
                label={"PHONE NUMBER"}
                type={"text"}
                fullWidth
                value={initialState.cellPhone}
                onChange={(e) => {
                  this.handleChange('cellPhone', e)
                }}
                style={styles.inputText}
              />
              <FormHelperText id="component-error-text"
                              style={styles.error}>{this.state.errors.cellPhone}</FormHelperText>
            </Grid>
          </Grid>
          <Grid container style={{margin: '10px 0 15px 0'}}>
            <Grid item xs={12}>
              <InputLabel style={styles.ftText}>EMAIL</InputLabel><br/>
              <Input
                name={"emailId"}
                placeholder={"Email Address"}
                label={"EMAIL"}
                type={"text"}
                fullWidth
                value={initialState.emailId}
                onChange={(e) => {
                  this.handleChange('emailId', e)
                }}
                style={styles.inputText}
              />
              <FormHelperText id="component-error-text"
                              style={styles.error}>{this.state.errors.emailId}</FormHelperText>
            </Grid>
          </Grid>
          <Grid container style={{margin: '10px 0 15px 0'}}>
            <Grid item xs={12}>
              <InputLabel style={styles.ftText}>STREET</InputLabel><br/>
              <Input
                name={"street1"}
                placeholder={"street1"}
                type={"text"}
                fullWidth
                value={initialState.address.street1}
                onChange={(e) => {
                  this.handleChange('street1', e)
                }}
                style={styles.inputText}
              />
              <FormHelperText id="component-error-text"
                              style={styles.error}>{this.state.errors.address.street1}</FormHelperText>
            </Grid>
          </Grid>
          <Grid container style={{margin: '10px 0 15px 0'}}>
            <Grid item xs={12}> <InputLabel style={styles.ftText}>APARTMENT/SUITE ETC.</InputLabel><br/>
              <Input
                name={"street2"}
                placeholder={"street2"}
                type={"text"}
                fullWidth
                value={initialState.address.street2}
                onChange={(e) => {
                  this.handleChange('street2', e)
                }}
                style={styles.inputText}
              />
              {/*<FormHelperText id="component-error-text"
                                            style={styles.error}>{this.state.errors.address.street2}</FormHelperText>*/}

            </Grid>
          </Grid>
          <Grid container style={{margin: '10px 0 15px 0'}}>
            <Grid item xs={12}>
              <InputLabel style={styles.ftText}>CITY</InputLabel><br/>
              <Input
                name={"city"}
                placeholder={"city"}
                type={"text"}
                fullWidth
                value={initialState.address.city}
                onChange={(e) => {
                  this.handleChange('city', e)
                }}
                style={styles.inputText}
              />
              <FormHelperText id="component-error-text"
                              style={styles.error}>{this.state.errors.address.city}</FormHelperText>
            </Grid>
          </Grid>
          <Grid container style={{margin: '10px 0 15px 0'}}>
            <Grid item xs={12}>
              <InputLabel style={styles.ftText}>STATE</InputLabel><br/>
              {/*<Input
                                name={"state"}
                                placeholder={"state"}
                                type={"text"}
                                fullWidth
                                value={initialState.address.state ? initialState.address.state.toUpperCase() : ''}
                                onChange={(e) => {
                                    this.handleChange('state', e)
                                }}
                                style={styles.inputText}
                            />*/}
              <select
                value={initialState.address.state}
                onChange={(ev) => this.handleChange('state', ev)}
                style={{
                  fontFamily: webFont,
                  fontSize: "18px",
                  fontWeight: 300,
                  border: 'none',
                  width: '100%',
                  borderBottom: '1px solid rgb(118, 118, 118)',
                  outline: 'none'
                }}
              >
                <option value="">Select State</option>
                {stateList.map(st => (
                  <option value={st.id} key={st.id} style={{ fontFamily: 'Poppins'}}>{st.id}</option>
                ))}
              </select>
              <FormHelperText id="component-error-text"
                              style={styles.error}>{this.state.errors.address.state}</FormHelperText>
            </Grid>
          </Grid>
          <Grid container style={{margin: '10px 0 15px 0'}}>
            <Grid item xs={12}>
              <InputLabel style={styles.ftText}>ZIP CODE</InputLabel><br/>
              <Input
                name={"zip"}
                placeholder={"zip"}
                type={"text"}
                fullWidth
                value={initialState.address.zip}
                onChange={(e) => {
                  this.handleChange('zip', e)
                }}
                style={styles.inputText}
              />
              <FormHelperText id="component-error-text"
                              style={styles.error}>{this.state.errors.address.zip}</FormHelperText>

            </Grid>

          </Grid>

          <Grid container justify='center' alignContent='center' style={{marginTop: '20px'}}>
            {/*<Button style={{ ...styles.setFont, ...styles.nextBtn }} onClick={() => this.props.changeProgressStep(4)}>*/}
            {/*Next*/}
            {/*</Button>*/}
            <Fab
              data-test-id={"bkgthreesub"}
              variant={"extended"}
              type="submit"
              style={{...styles.setFont, ...styles.nextBtn}}
            >
              Next
            </Fab>
          </Grid>

          {this.props.stepOne && <Grid container justify='center' alignContent='center' style={{marginTop: '20px'}}>
            {/*<Button style={{ ...styles.setFont, ...styles.nextBtn }} onClick={() => this.props.changeProgressStep(4)}>*/}
            {/*Next*/}
            {/*</Button>*/}
            <Fab
              data-test-id={"bkgthreesub"}
              variant={"extended"}
              type="button"
              style={{...styles.setFont, ...styles.nextBtn}}
              onClick={this.props.closeModal}
            >
              Cancel
            </Fab>
          </Grid>}
        </form>
      </Grid>);
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    cart: state.bookings.cart,
    diner: state.user.diner,
    chef: state.user.chef,
    customBookingAddress: state.bookings.customBookingAddress,
    inProgressBooking: state.bookings.inProgressBooking,
    isRecurring: state.bookings.isRecurring,
    selectedChef: state.bookings.selectedChef,
    selectedChefId: state.bookings.selectedChefId,
  };
};
const ProgressThreeWithData = compose(
  graphql(UPDATE, {name: "updateUser"}),
  graphql(UPDATE_CHEF, {name: "updateChef"}),
  graphql(UPDATE_IN_PROGRESS_BOOKING, { name: "updateInProgressBooking" }),
)(InProgress3);

const InProgressThree = connect(mapStateToProps)(ProgressThreeWithData);
export default InProgressThree;

const styles = {
  nextBtn: {
    minWidth: 240,
    textAlign: 'center',
    borderRadius: 24,
    backgroundColor: primaryColor,
    color: '#fff',
    height: 48,
    boxShadow: 'none',
    fontSize: 18,
    textTransform: 'none',
    fontWeight: 'normal',
  },

  avatarImg: {
    width: "86px",
    height: "86px",
    borderColor: primaryColor,
    borderWidth: 7
  },

  userName: {
    fontFamily: webFont,
    fontSize: "30px",
    color: textBlack,
    weight: 500,
    paddingLeft: 0,
    textAlign: "left"
  },

  ftText: {
    fontFamily: webFont,
    fontSize: "14px",
    color: textBlack,
    fontWeight: 500
  },
  frlabel: {
    fontFamily: webFont,
    fontSize: "20px",
    color: textPrimary,
    marginLeft: 80,
    fontWeight: 500,
    marginBottom: 30,
    marginTop: 30
  },
  inputText: {
    fontFamily: webFont,
    fontSize: "18px",
    fontWeight: 300,
  },
  setFont: {
    fontFamily: webFont
  },

  showBtn: {
    borderRadius: 40,
    paddingLeft: 20,
    paddingRight: 20
  },
  displayBlock: {
    display: "block"
  },
  displayNone: {
    display: "none"
  },
  error: {fontSize: 12, color: "red", fontFamily: webFont},
  submitButton: {
    borderRadius: 25,
    backgroundColor: primaryColor,
    border: "none",
    width: "200px",
    color: "white",
    height: 40,
    fontFamily: webFont,
    textTransform: "none",
    fontWeight: "500"
  },
};
